import { createAction } from 'Utility/Redux';
import { ILevelState, ILevelStateTaskData } from './ILevelState';
import { IScoreEntry } from '../../Utility/SDK/Drivers/IScoreEntry';

enum Types {
    SET_LEVEL_LOADED = 'setLevelLoaded',
    LEVEL_INTRO = 'levelIntro',
    LEVEL_ACTIVE = 'levelActive',
    SET_LEVEL_LEADERBOARD = 'setLevelLeaderboard',
    SHOW_GOLD_CARD_TUTORIAL = 'showGoldCardTutorial',
    EXIT_LEVEL = 'exitLevel',
}

export const LevelActions = {
    setLevelLoaded: createAction(Types.SET_LEVEL_LOADED, resolve => (levelState: Partial<ILevelState>) =>
        resolve(levelState)
    ),
    levelIntro: createAction(Types.LEVEL_INTRO),
    levelActive: createAction(Types.LEVEL_ACTIVE),
    setLevelLeaderboard: createAction(Types.SET_LEVEL_LEADERBOARD, resolve => (entries: IScoreEntry[]) =>
        resolve<IScoreEntry[]>(entries)
    ),
    showGoldCardTutorial: createAction(Types.SHOW_GOLD_CARD_TUTORIAL, resolve => () => resolve()),
    exitLevel: createAction(Types.EXIT_LEVEL),
};
